import axios from "axios";
import uid from "assets/scripts/utils/uid";
import moment from "moment";
import { apiRequest } from "./auth/authActions";
import isAxiosError from "../utils/isAxiosError";
function getPayload(params) {
    const files = {};
    const json = JSON.stringify(params || {}, (_key, value) => {
        if (value instanceof Blob) {
            const fileId = `__file_${uid()}__`;
            files[fileId] = value;
            return fileId;
        }
        return value;
    });
    let data = json;
    let contentType = "application/json";
    const fileIds = Object.keys(files);
    if (fileIds.length > 0) {
        const formData = new FormData();
        formData.append("payload", json);
        for (const fileId of fileIds) {
            formData.append(fileId, files[fileId]);
        }
        data = formData;
        contentType = "multipart/form-data";
    }
    return {
        data,
        contentType
    };
}
/**
 * Class to wrap the setup of an axios instance used for all ajax requests
 */
class ApiService {
    /* Instantiates and customizes axios with proper headers based on build selected */
    constructor() {
        this._defaultHeaders = {};
        this._dispatchQueue = [];
        this._axios = axios.create();
        this._defaultHeaders["Accept"] = "application/json"; // tslint:disable-line:no-string-literal
        if (process.env.NODE_ENV !== "production") {
            this._defaultHeaders["X-Development-Authorize"] = "dd24ace3-1751-4591-885b-697320da3c80";
        }
        else {
            this._defaultHeaders["X-XSRF-TOKEN"] = window.DCM_SETTINGS.XSRF_TOKEN;
        }
    }
    getXsrfToken() {
        return this._defaultHeaders["X-XSRF-TOKEN"];
    }
    updateXsrfToken(token) {
        this._defaultHeaders["X-XSRF-TOKEN"] = token;
    }
    post(url, authenticated, params) {
        const { data, contentType } = getPayload(params);
        const headers = {
            ...this._defaultHeaders,
            "Content-Type": contentType
        };
        if (this._store != null) {
            headers["X-Selected-Locale"] = this._store.getState().i18n.locale;
        }
        const timestamp = moment().toISOString();
        const promise = this._axios.request({
            method: "post",
            url,
            data,
            headers
        });
        let statusId = null;
        return promise
            .then((response) => {
            statusId = response.status;
            return response;
        }, (error) => {
            if (isAxiosError(error)) {
                statusId = error.response.status;
            }
            throw error;
        })
            .finally(() => {
            this._dispatchQueue.push({ url, authenticated, timestamp, statusId });
            this._dispatch();
        });
    }
    setStore(store) {
        if (store == null || this._store != null) {
            throw new Error("Unexpected state");
        }
        this._store = store;
        this._dispatch();
    }
    _dispatch() {
        if (this._store != null) {
            while (this._dispatchQueue.length > 0) {
                const { url, authenticated, timestamp, statusId } = this._dispatchQueue.shift();
                this._store.dispatch(apiRequest(url, authenticated, timestamp, statusId));
            }
        }
    }
}
const apiService = new ApiService();
export { apiService };



// WEBPACK FOOTER //
// ./src/assets/scripts/domain/apiService.ts